import 'vant/lib/image/style/index';
import 'vant/lib/button/style/index';

import Image from 'vant/lib/image/index';
import Button from 'vant/lib/button/index';

import MSentry from '@mfex/mfex-sentry-vue';
import config from 'site-config';
import store from 'v-store/index';
import type {App} from 'vue';

function setupVant(app: App) {
    [Image, Button].forEach(comp => {
        app.use(comp);
    });
}

function setupSentry(app: App) {
    MSentry.init({
        app,
        dsn: config.SENTRY.DSN,
        transactionName: 'live'
    });
}

export function setup(app: App) {
    setupVant(app);
    app.use(store);
    app.mount('#app');
    setupSentry(app);
}
